/**
 * @Description 集客点列表-每一项
 */
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import { gatherClientStatus } from '../../../GatherClientDrawer/ts-config';
import { getDetail } from '@/common/api/sitemapgather';
import { useRef } from 'react';


// #FF861D 审批中
// #2BC58B 已通过
// #F23030 已驳回、已拒绝
export const StatusColor = {
  [gatherClientStatus.PASS]: {
    text: '已通过',
    color: '#2BC58B'
  },
  [gatherClientStatus.APPROVAL]: {
    text: '审批中',
    color: '#FF861D'
  },
  [gatherClientStatus.REJECT]: {
    text: '已拒绝',
    color: '#F23030'
  },
  [gatherClientStatus.DENY]: {
    text: '已驳回',
    color: '#F23030'
  },
  [gatherClientStatus.NOT_RELATION]: {
    text: '未录入',
    color: '#222'
  },
};
const GatherItem = ({
  clusterId,
  detail,
  setDetailDrawer,
  polygonInfo
}) => {
  const isLockRef = useRef<boolean>(false);
  const handleClick = () => {
    if (isLockRef.current) return;
    isLockRef.current = true;
    getDetail({ modelClusterId: clusterId }).then((data) => {
      const value = {
        ...data,
        radius: polygonInfo?.radius,
        polygon: polygonInfo?.polygon,
      };
      setDetailDrawer({
        visible: true,
        value,
        // id: detailDrawer.id
      });
    }).finally(() => {
      isLockRef.current = false;
    });
  };
  return <div className={styles.gatherItem}
    onClick={handleClick}
  >
    <div className={styles.title}>
      <span className={styles.titleName}>{detail.name}</span>
      <IconFont iconHref={'pc-common-icon-a-iconarrow_down'} className={styles.icon}/>
      <span
        style={{
          color: StatusColor[detail?.status]?.color || '#222'
        }}
        className={styles.statusName}>{detail?.statusName || ''}</span>
    </div>
    <div className={styles.info}>
      <div className={styles.card}>
        <div className={styles.label}>录入人：</div>
        <div className={styles.value}>{detail.creatorName || '-'}</div>
        <div className={styles.split}>|</div>
        <div className={styles.value}>{detail.createdAt || '-'}</div>
      </div>
      <div className={styles.card}>
        <div className={styles.label}>租金单价：</div>
        <div className={styles.value}>{detail.rent ? `${detail.rent}㎡/月/元` : '-'}</div>
      </div>
      <div className={styles.card}>
        <div className={styles.label}>转让费：</div>
        <div className={styles.value}>
          {detail.assignmentFee ? `¥${detail.assignmentFee}` : '-'}
        </div>
      </div>
    </div>
  </div>;
};
export default GatherItem;
